export function getCookie(cname)
{
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++)
    {
        let c = ca[i].trim();
        if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
}

export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/;domain="+this.cookieDomain//path=/是根路径
    // document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/;domain=localhost"//path=/是根路径
}
//删除cookie
export function delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
export function download1 (url) {
    var src = url
    var imgNameArr = url.split('/')
    var imgName = imgNameArr[imgNameArr.length - 1]
    var canvas = document.createElement('canvas');
    var img = document.createElement('img');
    img.onload = function() {
        canvas.width = img.width;
        canvas.height = img.height;
        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0, img.width, img.height);
        // window.navigator.msSaveBlob(canvas.msToBlob(),'image.jpg');
        // saveAs(imageDataUrl, '附件');
        canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
        canvas.toBlob((blob)=>{
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = imgName;
            link.click();
        }, "image/jpeg");
    }
    img.setAttribute("crossOrigin",'Anonymous');
    img.src = src;
}
/** 前端下载/保存文件 */
function saveAs(href, fileName) {
  const isBlob = href instanceof Blob;
  const aLink = document.createElement('a');
  aLink.href = isBlob ? window.URL.createObjectURL(href) : href;
  aLink.download = fileName;
  aLink.click();
  if (isBlob) setTimeout(() => URL.revokeObjectURL(aLink.href), 100);
}

export function download(url, options = {}) {
  options = Object.assign({ method: 'get', headers: {} }, options);

  return new Promise((reslove, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.responseType = 'blob'; // options.responseType;
    if (options.headers) {
      for (const key in options.headers) xhr.setRequestHeader(key, options.headers[key]);
    }
    var imgNameArr = url.split('/')
    var imgName = imgNameArr[imgNameArr.length - 1]
    xhr.onload = () => {
      // 从 Content-Disposition 中获取文件名示例
      const cd = xhr.getResponseHeader('Content-Disposition');
      if (cd && cd.includes('fileName') && !options.fileName) {
        options.fileName = cd.split('fileName=')[1];
      } else {
        options.fileName = decodeURIComponent(imgName || 'download-file');
      }

      if (+xhr.status == 200) {
        saveAs(xhr.response, options.fileName);
        reslove(options.fileName);
      }
    };
    xhr.onerror = err => reject(err);
    xhr.addEventListener(
      'progress',
      event => {
        if (options.onProgress) options.onProgress(event.loaded, event.total, event);
      },
      false
    );

    xhr.open(options.method, url, true);
    xhr.send(options.body);
  });
}